export const X_SHARE_DIALOG_TITLE = "Share this prediction on X";
export const X_SHARE_DIALOG_SUBTITLE =
  "Free · No signup · Posts directly to your X account";
export const X_MENTION = "@Prediction_Hero";
export const X_DEFAULT_HASHTAGS = "#PredictionMarkets #PredictionHero";
export const X_POST_LIMIT = 280;
export const X_URL_LENGTH = 23;
export const X_COUNTER_HINT =
  "Space left for your text. A free X account allows 280 characters; the link (X counts it as 23), the @Prediction_Hero mention and the hashtags are already counted in.";
